import Button from '@mui/material/Button'
import { useState, lazy, Suspense } from 'react'

const AddTagsModal = lazy(() => import('./AddTagsModal'))

const AddTagsButton = ({ transactionCounterparty, setDisplayTags }) => {
  const [modalVisible, setModalVisible] = useState(false)
  return (
    <>
      <Button
        sx={{ fontSize: 14 }}
        disableElevation
        size='small'
        type='submit'
        variant='text'
        color='primary'
        onClick={() => {
          setModalVisible(true)
        }}
      >
        + Add Tags
      </Button>
      {modalVisible && (
        <Suspense fallback={<></>}>
          <AddTagsModal
            modalVisible={modalVisible}
            handleCancelModal={() => setModalVisible(false)}
            transactionCounterparty={transactionCounterparty}
            setDisplayTags={setDisplayTags}
          />
        </Suspense>
      )}
    </>
  )
}

export default AddTagsButton
